module.exports = __webpack_public_path__ + "static/media/diptanu-debnath.40bc77ce.jpeg";